// /home/ananun/fluorescence.pro/admin/src/components/client/client.jsx
// client.jsx

import React, { useState, useEffect, useMemo } from "react";
import SinglePage from "../SinglePage";
import { useParams, useLocation } from "react-router-dom";
import * as API from "../../helpers/api";
import { isDraftMode } from "../../helpers/ensureDraftOnAdd";
import config from "../../config";
import Loading from "../modules/loading";
import { useUser } from "../../helpers/userContext";
import moment from "moment";
import parse from "html-react-parser";
import { useLang } from "../../helpers/language";
import NProgress from "nprogress";

export default function Client() {
	const [isBusy, setBusy] = useState(true);
	let id = useParams().id;
	const route = config.api.client;
	const { lang } = useLang();
	const { user } = useUser();
	const location = useLocation();
	const [permissions, setPermissions] = useState([]);

	const [index, setIndex] = useState(0);
	const [name, setName] = useState("");
	const [phone, setPhone] = useState("+3749");
	const [debt, setDebt] = useState("");
	const [history, setHistory] = useState([]);

	const modelSendToServer = {
		index,
		name,
		phone,
		history,
		debt,
	};

	useEffect(() => {
		(async () => {
			NProgress.start();
			let debts = [],
				debtsRepayed = [];
			try {
				// get all debt object which has client id in it
				debts = await API.get(config.api.debt, {
					client: id,
				});
				debtsRepayed = await API.get(config.api.debtRepayment, {
					client: id,
				});
				setDebt(
					debts.reduce((acc, debt) => {
						return acc + debt.amount;
					}, 0) -
						debtsRepayed.reduce((acc, debt) => {
							return acc + debt.amount;
						}, 0)
				);
			} catch (error) {
				console.log(error);
			}

			if (id !== "add" && !isDraftMode(location.search)) {
				let currentItem = await API.get(route, {
					_id: id,
				});

				setIndex(currentItem[0]?.index);
				setName(currentItem[0]?.name);
				setPhone(currentItem[0]?.phone);
				setHistory(currentItem[0]?.history);
			}
			setBusy(false);
		})();
		// eslint-disable-next-line
	}, [isBusy]);

	useEffect(() => {
		let tempPermissions = [];
		user?.role?.permissions?.forEach((permission) => {
			if (permission.name === "client") {
				permission.inputs.forEach((input) => {
					tempPermissions.push(input);
				});
			}
		});
		setPermissions([...tempPermissions]);
	}, []);

	if (isBusy) return <Loading />;
	else
		return (
			<SinglePage
				isBusy={isBusy}
				setBusy={setBusy}
				route={route}
				id={id}
				permissions={permissions}
				permissionModel="client"
				modelSendToServer={modelSendToServer}
				inputs={[
					{
						value: index,
						setter: setIndex,
						type: "number",
						usageType: "number",
						label: config.translate.index[lang],
						placeholder: config.translate.index[lang],
						permissionModel: "index",
					},
					{
						value: name,
						setter: setName,
						type: "textfield",
						usageType: "textfield",
						label: config.translate.name[lang],
						placeholder: config.translate.name[lang],
						permissionModel: "name",
					},

					{
						value: phone,
						setter: (phoneNumber) => {
							setPhone(
								phoneNumber
									.replace(/^0+/, "")
									.replace(/-/g, "")
									.replace(/\s/g, "")
									.replace(/\(/g, "")
									.replace(/\)/g, "")
							);
						},
						type: "textfield",
						usageType: "textfield",
						label: config.translate.phone[lang],
						placeholder: config.translate.phone[lang],
						permissionModel: "phone",
					},
					{
						value: debt,
						// setter: setDebt,
						disabled: true,
						type: "number",
						usageType: "number",
						label: config.translate.debt[lang],
						placeholder: config.translate.debt[lang],
						permissionModel: "debt",
					},
				]}
			/>
		);
}
